import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	hasError: boolean
	isDisabled: boolean
	isFocus: boolean
	isFocusVisible: boolean
	isHovered: boolean
	isReadOnly: boolean
}

export const InputContainer = styled.div<Props>`
	cursor: ${({ isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? 'auto' : 'text')};
	display: flex;
	justify-content: space-between;
	column-gap: 8px;
	background-color: ${({ isHovered, isFocusVisible, isDisabled, isFocus, isReadOnly, hasError, theme }) => {
		if (isDisabled) return theme.color.input.backgroundDisabled
		if (isReadOnly) return theme.color.input.backgroundReadOnly
		if (isHovered || isFocusVisible || isFocus)
			return hasError ? theme.color.input.backgroundErrorHover : theme.color.input.backgroundHover
		return hasError ? theme.color.input.backgroundError : theme.color.input.background
	}};
	border: 1px ${({ isReadOnly }) => (isReadOnly ? 'dashed' : 'solid')} ${({
		isHovered,
		isFocusVisible,
		isFocus,
		isDisabled,
		isReadOnly,
		hasError,
		theme,
	}) => {
		if ((isHovered || isFocusVisible || isFocus) && !(isDisabled || isReadOnly))
			return hasError ? theme.color.input.borderError : theme.color.input.borderHover
		return hasError ? theme.color.input.borderError : theme.color.input.border
	}};
	border-radius: 4px;
	box-shadow: ${({ isFocusVisible, hasError, isDisabled, isReadOnly, theme }) => {
		if (isFocusVisible && !(isDisabled || isReadOnly))
			return hasError
				? `0 0 0 2px ${theme.color.input.borderOutlineError} `
				: `0 0 0 1px ${theme.color.input.borderOutlineHover}`
		return 'none'
	}};
	color: ${({ isReadOnly, isDisabled, theme }) => {
		if (isDisabled) return theme.color.input.contentDisabled
		if (isReadOnly) return theme.color.input.content
		return theme.color.input.content
	}};
	font-family: ${({ theme }) => theme.font.family.base};
	font-size: ${helpers.font.size.base};
	line-height: 1.2;
	margin: 0 0 -3px;
	outline: 0;
	padding: 8px 12px 8px 10px;
	position: relative;
	text-align: left;
	transition: border 135ms ease, box-shadow 135ms ease, background-color 135ms ease;
	width: 100%;
`
